import React from 'react';

import './UpDownTransitionArrow.css'

const updownTransitionArrow = (props) => {

    return (
        <i className={props.up ? "up-arrow" : "down-arrow"} onClick={props.handleOnClick}></i> 
    );
}

export default updownTransitionArrow;



// WEBPACK FOOTER //
// ./src/components/UpDownTransitionArrow/UpDownTransitionArrow.js